module.exports = __webpack_public_path__ + "img/course120_summary_unit_timelines.5f6e25f1.png";